<template>
  <Drawer
    width="400"
    :title="`${openedSalesPromoFee ? '编辑' : '新增'}业务费`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model = "formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <div class="formIten">
          <FormItem
            label="销售项目"
            prop="sales"
          >
            <Select
              v-model="formItem.sales"
              style="width: 350px"
              :remote-method="searchSalesFunc"
              filterable
              clearable
              v-loadMore="loadMore"
              :loading="customerLoading"
              placeholder="搜索销售项目"
            >
              <Option
                v-for="option in salesList"
                :value="option._id"
                :key="option._id"
                style="width: 350px;white-space:normal"
                :disabled="option.disable"
              >{{
                  option && option.abbr ? option.abbr : ""
                }}</Option>
            </Select>
          </FormItem>
          <FormItem label="联系人" prop="customerContact">
              <Select
              v-model="formItem.customerContact"
              style="width: 350px"
              @on-query-change="getCustomerContactMethod"
              filterable
              clearable
              :loading="customerLoading"
              placeholder="搜索联系人"
            >
              <Option
                v-for="option in customerContactList"
                :value="option._id"
                :key="option._id"
                style="width: 350px;white-space:normal"
                :disabled="option.disable"
              >{{ option && option.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="费用" prop="fee">
              <Input
                v-model="formItem.fee"
                clearable
                type="number"
                number
                placeholder="请输入联系费用"
              >
              </Input>
          </FormItem>
          <FormItem label="停用" prop="active">
            <i-switch v-model="isActive" true-color="#ff4949" @on-change="changeActive"></i-switch>
          </FormItem>
          <FormItem label="备注" prop="remark">
              <Input
                v-model="formItem.remark"
                type="textarea"
                placeholder="请输入备注..."
              />
            </FormItem>
        </div>
      </Form>
    </div>
    <div class="footer">
      <Button
        type="primary"
        style="width: 150px; margin-left: 12px"
        @click="handleSubmit('formItem')"
      >保存</Button>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import loadMore from '@/directives/loadMore'
import dayjs from "dayjs";
import _ from "lodash";

export default {
  name: "EditSalesPromoFeeDrawer",
  directives: {
    loadMore,
  },
  data() {
    return {
      drawerOpened: false,
      customerLoading: false,
      openedSalesPromoFee: null,
      formItem: {
        customerContact: null,
        fee: null,
        active: null,
        remark: null,
        sales: null,
      },
      salesList: [],
      isActive: false,
      salesPage: 0,
      salesLimit: 20,
      isSurplus: true,
      ruleValidate: {
        customerContact: [
          {
            required: true,
            type: "string",
            message: "联系人为必选项",
            trigger: "submit",
          },
        ],
        fee: [
          {
            required: true,
            type: "number",
            message: "费用为必填项",
            trigger: "change",
          },
        ],
        sales: [
          {
            required: true,
            type: "string",
            message: "销售项目为必选项",
            trigger: "change",
          },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      customerContactList: state => state.customerContact.customerContactList,
    })
  },
  methods: {
    ...mapActions({
      createSalesPromoFeeRecord: "salesPromoFeeRecord/createSalesPromoFeeRecordAction",
      getSales: "sales/getSalesAction",
      getSalesById: "sales/getSalesByIdAction",
      updatePromoFee: "salesPromoFeeRecord/updatePromoFeeAction",
      getCustomerContact: "customerContact/getCustomerContactAction",
    }),
    async openDrawer(salesPromoFee) {
      this.openedSalesPromoFee = null
      this.salesList = []
      this.$refs["formItem"].resetFields();
      if (salesPromoFee) {
        this.openedSalesPromoFee = salesPromoFee;
        if (salesPromoFee.customerContact) {
          await this.getCustomerContactMethod(salesPromoFee.customerContact.name)
          this.formItem.customerContact = salesPromoFee.customerContact._id;
        }
        this.formItem.fee = salesPromoFee.fee;
        if (salesPromoFee.sales) {
          this.salesList.push(salesPromoFee.sales)
          this.formItem.sales = salesPromoFee.sales._id;
        }
        this.formItem.active = salesPromoFee.active;
        if (salesPromoFee.active === true) {
          this.isActive = false;
        }else if(salesPromoFee.active === false){
          this.isActive = true
        }else{
          this.isActive = false;
        }
        this.formItem.remark = salesPromoFee.remark;
      }else{
        this.formItem= {
          customerContact: null,
          fee: null,
          active: null,
          remark: null,
          sales: null,
        }
        this.isActive = null
      }
      this.drawerOpened = true;
    },
    async getSalesMethod(cus_name) {
      let api = {
        skip: this.salesPage * 20,
        limit: this.salesLimit,
        cus_name
      };
      if (this.openedSalesPromoFee && cus_name === this.openedSalesPromoFee.sales._id) {
        const sales = await this.getSalesById(cus_name)
        this.salesList.push(sales)
      } else {
        const data = await this.getSales(api)
        if(data.salesList.length>0) {
          this.salesList.push(...data.salesList)
        }else if(data.salesList.length === 0) {
          this.salesList.push({abbr: '已经到底了', _id:dayjs()+'down', customer:{name: '~~~'}, disable: true})
          this.isSurplus = false
        }
      }
      
    },
    async searchSalesFunc(query) {
      this.searchSales = query
      this.salesList = []
      this.isSurplus = true
      this.salesPage = 0
      if (this.searchSales !== "") {
        this.customerLoading = true;
        await this.getSalesMethod(this.searchSales);
        this.customerLoading = false;
      }
    },
    async getCustomerContactMethod (cus_name) {
      await this.getCustomerContact({name: cus_name})
    },
    async loadMore() {
      if (this.isSurplus) {
        this.salesPage += 1
        await this.getSalesMethod(this.searchSales)
      }
    },
    changeCustomerContact(data) {
      this.formItem.customerContact = data.data
    },
    changeActive(status) {
      this.formItem.active = !status;
    },
    async handleSubmit(name) {
      this.$refs[name].validate(async valid => {
        if (valid) {
          try {
            if (this.openedSalesPromoFee) {
              await this.updatePromoFee({
                id: this.openedSalesPromoFee._id,
                data: this.formItem
              });
            } else {
              let formItem = _.cloneDeep(this.formItem);
              for (const key in formItem) {
                if (!formItem[key]) {
                  delete formItem[key];
                }
              }
              await this.createSalesPromoFeeRecord({ form: formItem});
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    }
  },
}
</script>

<style lang="stylus" scoped>
.footer
    position fixed
    bottom 0px
    width 100%
    height 64px
    background-color #f2f6fa
    display flex
    flex-direction column
    justify-content center
    transition 0.2s
    z-index 1
</style>